import { times } from './times';

export function range(start: number, end: number, step = 1) {
  return times(end - start, n => start + n * step);
}
